/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@atlaskit/css';

import { type PropsWithChildren } from 'react';
import { token } from '@atlaskit/tokens';
import { Flex } from '@atlaskit/primitives/compiled';

const styles = cssMap({
	container: {
		paddingInline: token('space.200'),
		maxWidth: '100%',
		paddingLeft: token('space.1000'),
		paddingRight: token('space.1000'),
		height: '100%',
	},
});

type PageProps = PropsWithChildren;

export const Page = ({ children }: PageProps): JSX.Element => {
	return (
		<Flex direction="column" xcss={styles.container}>
			{children}
		</Flex>
	);
};
